module.exports = __webpack_public_path__ + "static/media/firmness.dbad1944.svg";